export default "__VITE_ASSET__D6TGx7yJ__"